import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="max-w-xl mx-auto px-4 py-24 text-center">
      <h1 className="font-display text-7xl text-coral">404</h1>
      <p className="mt-4 font-display text-2xl uppercase">Wiped out. This page drifted away.</p>
      <Link to="/" data-testid="not-found-home-link" className="btn-pop bg-sunny mt-8">Paddle home</Link>
    </div>
  );
}
